import { Component } from 'react';

// Si una pantalla truena al dibujarse, la app quedaba en blanco y el único
// botón que funcionaba era "atrás", que la cerraba. Ahora queda un aviso con
// salida. No reporta a ningún lado: solo deja la app usable.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[pantalla] falló al dibujarse:', error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div style={{ minHeight: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, background: 'var(--bg)' }}>
        <div style={{ maxWidth: 420, width: '100%', background: 'var(--surface)', borderRadius: 16, padding: 24, display: 'flex', flexDirection: 'column', gap: 12, boxShadow: 'var(--shadow-card)' }}>
          <h1 style={{ margin: 0, fontSize: 20 }}>Algo falló en esta pantalla</h1>
          <p style={{ margin: 0, color: 'var(--text-2)', fontSize: 14, lineHeight: 1.5 }}>
            Lo que estaba guardado sigue guardado. Vuelve al inicio para seguir trabajando.
          </p>
          <button className="btn btn--primary btn--full" onClick={() => { window.location.assign('/'); }}>
            Volver al inicio
          </button>
        </div>
      </div>
    );
  }
}
